<ng-container *ngIf="isDialogOpened">
  <kendo-window [title]="title"
                [minWidth]="500"
                [width]="850"
                [minHeight]="700"
                [height]="700"
                (close)="cancel()"
                class="top-left-counter-card k-window-content min-height-150 confirm-dialog app-confirm-dialog kendo-window-with-titlebar">
    <br />
  <div class="dialog-container">
    <div class="grid-table">
      <kendo-grid #kendoGrid class="delete-template-grid"
                  [pageable]="false"
                  [data]="templates"
                  [loading]="loading"
                  [selectable]="selectableSettings"
                  kendoGridSelectBy="Oid"
                  (selectionChange)="onSelect($event)">
        <kendo-grid-column *ngFor="let col of columns; trackBy: trackByField"
                           [field]="col.field"
                           [width]="col.width"
                           [title]="col.title | translate"
                           [columnMenu]="col.field !== 'checkbox'"
                           [class]="col.field === 'PublishStatusId' ? 'publish-status-field' : ''">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'date'">
            {{dataItem[col.field] | date: 'dd/MM/yyyy'}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'datetime'">
            {{dataItem[col.field] | date: 'dd/MM/yyyy  HH:mm:ss'}}
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
    <div class="dialogButtonBar">
      <div class="reportDesignerButtonBarBorder">
        <div class="ButtonBar">
          <button kendoButton class="ButtonWidth_110px" [disabled]="!enableDelete" (click)="deleteTemplate()">{{ 'reportDesignerDialog.deleteTemplate' | translate }}</button>
          <button kendoButton class="ButtonWidth_110px" (click)="cancel()">{{ 'reportDesignerDialog.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
    
  </kendo-window>
  <div class="k-overlay overlay-confirm-dialog"></div>
</ng-container>
